module.exports = __webpack_public_path__ + "img/nyt.883d89af.png";